import { Logo } from './Logo';

export const GoogleButton = () => {
  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button type="button" data-testid="google-auth-btn" onClick={handleGoogle} className="btn-ghost w-full !py-3 !normal-case !tracking-normal !font-body !text-sm">
      <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-4 h-4" />
      Continue with Google
    </button>
  );
};

export const AuthDivider = () => (
  <div className="flex items-center gap-3">
    <div className="flex-1 h-px bg-line" />
    <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">or</span>
    <div className="flex-1 h-px bg-line" />
  </div>
);

export const AuthShell = ({ title, subtitle, children, testId }) => (
  <div className="min-h-screen bg-ink grid-bg flex flex-col relative noise">
    <header className="px-6 py-5 relative z-10">
      <Logo testId="auth-logo-link" />
    </header>
    <main className="flex-1 flex items-center justify-center px-4 pb-16 relative z-10">
      <div className="w-full max-w-md fade-up" data-testid={testId}>
        <div className="mb-8">
          <h1 className="h-display text-3xl sm:text-4xl leading-[1.05]">{title}</h1>
          {subtitle && <p className="mt-3 text-sm text-slate-400 leading-relaxed">{subtitle}</p>}
        </div>
        <div className="card-brutal p-6 sm:p-8 space-y-5">{children}</div>
      </div>
    </main>
  </div>
);

export const Field = ({ label, children }) => (
  <div className="space-y-2">
    <label className="label">{label}</label>
    {children}
  </div>
);

export const inputClass = 'input';
export const primaryBtn = 'btn-primary';
export const secondaryBtn = 'btn-secondary';
